import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MonthsEnum } from '../enum/monthsEnum.enum';
import { MultiRegionService } from '../multiregion/multiregion.service';
import { IOption } from '../authentication/connection/interfaces/apiInterfaces';
@Injectable()
export class CalendarService {
  monthsString = new Array<string>();
  constructor(private _multiregionService: MultiRegionService, private _translateService: TranslateService) {
    this.monthsString.push(this._multiregionService.getLabel(MonthsEnum.FIRST));
    this.monthsString.push(
      this._multiregionService.getLabel(MonthsEnum.SECOND)
    );
    this.monthsString.push(this._multiregionService.getLabel(MonthsEnum.THIRD));
    this.monthsString.push(
      this._multiregionService.getLabel(MonthsEnum.FOURTH)
    );
    this.monthsString.push(this._multiregionService.getLabel(MonthsEnum.FIFTH));
    this.monthsString.push(this._multiregionService.getLabel(MonthsEnum.SIXTH));
    this.monthsString.push(
      this._multiregionService.getLabel(MonthsEnum.SEVENTH)
    );
    this.monthsString.push(
      this._multiregionService.getLabel(MonthsEnum.EIGHTH)
    );
    this.monthsString.push(
      this._multiregionService.getLabel(MonthsEnum.NINETH)
    );
    this.monthsString.push(this._multiregionService.getLabel(MonthsEnum.TENTH));
    this.monthsString.push(
      this._multiregionService.getLabel(MonthsEnum.ELEVENTH)
    );
    this.monthsString.push(
      this._multiregionService.getLabel(MonthsEnum.TWELFTH)
    );
  }

  getYears(): Array<IOption> {
    return this.calculateYears();
  }

  getMonths(): Array<IOption> {
    let months = new Array<IOption>();
    for (let index = 1; index < 13; index++) {
      months.push({ label: index.toString(), value: index.toString() });
    }
    return months;
  }

  getDays(year: number, month: number): IOption[] {
    let days = 31;
    if (month === 2) {
      days = this.isLeapYear(year) ? 29 : 28;
    }
    if (month === 4 || month === 6 || month === 9 || month === 11) {
      days = 30;
    }
    let arrayDays = new Array<IOption>();
    for (let index = 1; index <= days; index++) {
      arrayDays.push({ label: index.toString(), value: index.toString() });
    }
    return arrayDays;
  }

  private calculateYears(): Array<IOption> {
    let initYear = 2000;
    let actualYear = new Date().getFullYear();
    let years = new Array<IOption>();
    for (let index = initYear; index <= actualYear; index++) {
      years.push({ label: index.toString(), value: index.toString() });
    }
    return years.reverse();
  }
  private isLeapYear(year: number): boolean {
    return year % 4 === 0;
  }

  getAge(year: number, month: number, day: number) {
    let actualDate = new Date();
    let actualYear = actualDate.getFullYear();
    let actualMonth = actualDate.getMonth() + 1;
    let actualDay = actualDate.getDate();
    let newDate = this.getDateToString(actualYear, actualMonth, actualDay);
    let bornDate = this.getDateToString(year, month, day);
    return this.getAgeOfPerson(newDate, bornDate);
  }

  private getDateToString(year: number, month: number, day: number): string {
    let pad = '00';
    return (
      year.toString() +
      pad.substring(0, pad.length - month.toString().length) +
      month.toString() +
      pad.substring(0, pad.length - day.toString().length) +
      day.toString()
    );
  }

  private getAgeOfPerson(actualDate: string, bornDate: string): number {
    let intNewDate = Number(actualDate);
    let intBornDate = Number(bornDate);
    let temp = intNewDate - intBornDate;
    let age = Math.trunc(temp / 10000);
    return age;
  }

  public getYearsOld(): Array<IOption> {
    let adulthood: number = new Date().getFullYear() - 18;
    let initYear: number = new Date().getFullYear() - 100;
    let years = new Array<IOption>();
    for (let index = initYear; index <= adulthood; index++) {
      years.push({ label: index.toString(), value: index.toString() });
    }
    return years.reverse();
  }
  public getMinDate() {
    return new Date(2018, 0, 1);
  }
  public getMaxDate() {
    return new Date();
  }

  public getFiltersYear() {
    let initYear = this.minYear;
    let actualYear = new Date().getFullYear();
    let years = new Array<IOption>();
    for (let index = initYear; index <= actualYear; index++) {
      years.push({ label: index.toString(), value: index.toString() });
    }
    return years.reverse();
  }
  get minYear() {
    return 2018;
  }

  get es() {
    return {
      firstDayOfWeek: 1,
      dayNames: [
        this._translateService.instant('dates.sunday'),
        this._translateService.instant('dates.monday'),
        this._translateService.instant('dates.tuesday'),
        this._translateService.instant('dates.wednesday'),
        this._translateService.instant('dates.thursday'),
        this._translateService.instant('dates.friday'),
        this._translateService.instant('dates.saturday'),
      ],
      dayNamesShort: [
        this._translateService.instant('dates.sunday_abbr'),
        this._translateService.instant('dates.monday_abbr'),
        this._translateService.instant('dates.tuesday_abbr'),
        this._translateService.instant('dates.wednesday_abbr'),
        this._translateService.instant('dates.thursday_abbr'),
        this._translateService.instant('dates.friday_abbr'),
        this._translateService.instant('dates.saturday_abbr')
      ],
      dayNamesMin: [
        this._translateService.instant('SUNDAY_short'),
        this._translateService.instant('MONDAY_short'),
        this._translateService.instant('TUESDAY_short'),
        this._translateService.instant('WEDNESDAY_short'),
        this._translateService.instant('THURSDAY_short'),
        this._translateService.instant('FRIDAY_short'),
        this._translateService.instant('SATURDAY_short')
      ],
      monthNames: [
        this._translateService.instant('dates.january'),
        this._translateService.instant('dates.february'),
        this._translateService.instant('dates.march'),
        this._translateService.instant('dates.april'),
        this._translateService.instant('dates.may'),
        this._translateService.instant('dates.june'),
        this._translateService.instant('dates.july'),
        this._translateService.instant('dates.august'),
        this._translateService.instant('dates.september'),
        this._translateService.instant('dates.october'),
        this._translateService.instant('dates.november'),
        this._translateService.instant('dates.december'),
      ],
      monthNamesShort: [
        this._translateService.instant('dates.january_abbr'),
        this._translateService.instant('dates.february_abbr'),
        this._translateService.instant('dates.march_abbr'),
        this._translateService.instant('dates.april_abbr'),
        this._translateService.instant('dates.may_abbr'),
        this._translateService.instant('dates.june_abbr'),
        this._translateService.instant('dates.july_abbr'),
        this._translateService.instant('dates.august_abbr'),
        this._translateService.instant('dates.september_abbr'),
        this._translateService.instant('dates.october_abbr'),
        this._translateService.instant('dates.november_abbr'),
        this._translateService.instant('dates.december_abbr'),
      ],
      today: this._translateService.instant('dates.todayDate'),
      clear: this._translateService.instant('buttons_labels_common.delete'),
    };
  }
}
